const stats = [
  { id: 1, name: 'Combining lived experience and neuro-affirming professionals.', value: '' },
  { id: 2, name: 'We filter out deficit-based, outdated, and pathologising content.', value: '' },
  { id: 3, name: 'Built by a diverse, neurodivergent-led team advocating for change.', value: '' },
]

export default function HorizontalStats() {
  return (
    <div className="bg-dark-beige py-12 sm:py-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <dl className="grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-3">
          {stats.map((stat) => (
            <div key={stat.id} className="mx-auto flex max-w-xs flex-col gap-y-4 items-center py-auto">
              <dt className="text-xl md:text-2xl lg:text-3xl font-semibold text-dark-grey my-auto">{stat.name}</dt>
              <dd className="order-first text-3xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                {stat.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  )
}
